import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { ChargingStation } from '../../../../types';
import Card from '../../../card/Card';
import Link from '../../../link/Link';

type Props = {
  chargingStation: ChargingStation;
};

export default function ChargingStationCard({
  chargingStation: {
    streetAddress,
    city,
    state,
    zip,
    stationName,
    accessCode,
    evNetwork,
    evNetworkWeb,
  },
}: Props) {
  const { formatMessage } = useIntl();

  const address = `${streetAddress}, ${city}, ${state} ${zip}`;
  return (
    <Card sx={{ height: '100%' }}>
      <Box>
        <b>{stationName}</b> {address}
        &nbsp;
        <span>{accessCode}</span>
      </Box>
      <Box>
        {evNetwork && evNetworkWeb && (
          <Link to={evNetworkWeb} action="ev-network">
            {evNetwork}
          </Link>
        )}
        {(!evNetwork || !evNetworkWeb) && (
          <em>{formatMessage({ id: 'maps.chargingStationNetworkUnavailable' })}</em>
        )}
      </Box>
    </Card>
  );
}
